  import React, { useState } from "react";

  import FooterSecondary from "../components/FooterSecondary";
  import { ChevronRightIcon } from '@heroicons/react/solid'
  import { BookmarkAltIcon, BookOpenIcon, RssIcon, ViewListIcon } from '@heroicons/react/outline'
  import {Phone,UserCheck,Mail,MessageCircle} from "react-feather";
  export function PaginaErro404({ history }) {

    const [expanded, setExpanded] = useState(false);
    return (
      <>

        <div className="bg-white">
        <main className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center">


          <div className="text-center  pt-16">
            <img src="/images/logo-black.svg" className="mb-1 w-56" />

          </div>
          </div>
        <div className="max-w-xl mx-auto py-4 sm:py-4">
        <div className="text-center">

          <p className="mt-2 text-lg text-semibold text-mainGreen">404 ERROR</p>
        <h1 className="mt-2 text-4xl font-extrabold text-gray-600 tracking-tight sm:text-5xl">
          Página não encontrada.
        </h1>
        <p className="mt-2 text-lg text-gray-500">Não conseguimos encontrar o que você procura.</p>
        </div>
        <div className="mt-12">

        <ul role="list" className="mt-4 border-t border-b border-gray-200 divide-y divide-gray-200">
          <li  className="relative py-6 flex items-start space-x-4">
            <div className="flex-shrink-0">
                    <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-green-100">

                       <UserCheck className=" text-24 text-green-500"  />
                    </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-medium text-gray-700">
                      <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <a href="#" className="focus:outline-none">
                          <span className="absolute inset-0" aria-hidden="true" />
                         Já tem conta?
                        </a>
                      </span>
              </h3>
              <p className="text-base text-gray-500">Se já é cliente acesso, contate o seu administrador.</p>
            </div>

          </li>
          <li  className="relative py-6 flex items-start space-x-4">
            <div className="flex-shrink-0">
                    <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-green-100">

                       <Phone className=" text-24 text-green-500"  />
                    </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-medium text-gray-700">
                      <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <a href="#" className="focus:outline-none">
                          <span className="absolute inset-0" aria-hidden="true" />
                         Não é cliente acesso?
                        </a>
                      </span>
              </h3>
              <p className="text-base text-gray-500">Clique aqui e fale conosco.</p>
            </div>

          </li>
          <li  className="relative py-6 flex items-start space-x-4">
            <div className="flex-shrink-0">
                    <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-green-100">

                       <Mail className=" text-24 text-green-500"  />
                    </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-medium text-gray-700">
                      <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <a href="#" className="focus:outline-none">
                          <span className="absolute inset-0" aria-hidden="true" />
                        Precisa de suporte?
                        </a>
                      </span>
              </h3>
              <p className="text-base text-gray-500">Mande um e-mail para suporte@acessoenergia.com.br.</p>
            </div>

          </li>
          <li  className="relative py-6 flex items-start space-x-4">
            <div className="flex-shrink-0">
                    <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-green-100">

                       <MessageCircle className=" text-24 text-green-500"  />
                    </span>
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-medium text-gray-700">
                      <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                        <a href="#" className="focus:outline-none">
                          <span className="absolute inset-0" aria-hidden="true" />
                           Alguma dúvida?
                        </a>
                      </span>
              </h3>
              <p className="text-base text-gray-500">Veja as perguntas freequentes.</p>
            </div>

          </li>



        </ul>
        <div className="mt-8">
        <a href="/auth/login" className="text-base font-medium text-green-600 hover:text-green-500">
        Volte para o login<span aria-hidden="true"> &rarr;</span>
        </a>
        </div>
        </div>
        </div>
        </main>
          <FooterSecondary relativePosition="relative"/>
        </div>



      </>
    );
  }
